import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
	ContactForm,
	ContactFormResponse,
	Template,
	TemplateResponse
} from '@web-components/settings/settings.model';
import { catchError, map } from 'rxjs/operators';
import { PageRequest } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';

@Injectable()
export class SettingsDataService {
	constructor(
		private http: HttpClient,
		private messageService: MessageService
	) {}

	getContactFormPreviews(pageRequest: PageRequest): Observable<ContactForm> {
		const url = '/api/user/v1/contactform/preview';
		return this.http.post(url, pageRequest).pipe(
			map((res: ContactFormResponse): ContactForm => res.data),
			catchError(error => this.messageService.catchErrorFromBackend(error))
		);
	}

	duplicateContactForm(url: string, newName: string): Observable<Template> {
		return this.http.post(url, { name: newName }).pipe(
			map((res: TemplateResponse): Template => res.data),
			catchError(error => this.messageService.catchErrorFromBackend(error))
		);
	}

	deleteContactForm(url: string): Observable<Object> {
		return this.http
			.delete(url)
			.pipe(
				catchError(error => this.messageService.catchErrorFromBackend(error))
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/settings/settings.data.service.ts